'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import Icon from 'molecules/Icon';

import styles from 'components/Search/Hero/searchHero.module.scss';
import SearchDropdown from 'components/SearchDropdown';

import { useSearchAutocomplete } from 'utils/hooks/useSearchAutocomplete';

import type { FC, FormEvent } from 'react';

interface SearchHeroProps {
  searchTerm: string | null;
}

const SearchHero: FC<SearchHeroProps> = ({ searchTerm }) => {
  const router = useRouter();
  const { results, loading, inputValue, setInputValue, setInputValueQuiet, clearResults, isOpen } =
    useSearchAutocomplete();

  useEffect(() => {
    if (searchTerm) {
      setInputValueQuiet(searchTerm);
    }
  }, [searchTerm, setInputValueQuiet]);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clearResults();
    const path = inputValue ? `/search?q=${inputValue}` : '/search';
    router.push(path);
  };

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerInner}>
          <h1>Search</h1>
          <div className={styles.searchBox} role="search">
            <div className={styles.formWrapper} id="search">
              <form onSubmit={handleSearch}>
                <input
                  type="text"
                  name="search"
                  id="search"
                  placeholder="Search"
                  aria-label="Search for an entry"
                  className={styles.textField}
                  value={inputValue}
                  onChange={e => setInputValue(e.target.value)}
                />
                <button className={styles.searchButton} type="submit" aria-label="Submit search">
                  <Icon icon="icon-search" size={42} className={styles.iconColor} />
                </button>
              </form>
              <SearchDropdown
                key={inputValue}
                results={results}
                loading={loading}
                inputValue={inputValue}
                isOpen={isOpen}
                variant="hero"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchHero;
